<template>
  <el-dialog
      :close-on-click-modal="false"
    title="新建项目"
    append-to-body
    :visible.sync="visible"
    width="30%" 
    :before-close="handleClose"
   
  >
    <div class="block">
      <avue-form v-model="form" :option="option"  @submit="submit"> </avue-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      visible: false,
      option: {
        labelWidth: 100,
        column: [
          {
            label: "项目类型",
            type: "select",
            prop: "projectType", 
            span: 24,
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=zg_project_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              {
                required: true,
                message: "请输入姓名",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  props:{
    goType: {
      type: Number,
      default: 1
    }
  },

  methods: {
    showblock() {
      this.visible = true;
    },
    // 根据gotype判断选择类型后跳转页面或者导入导出
    submit(form, done){ 
      if(this.goType == 1){
         this.$router.push({
            path:'/zg/assetManageAdd',
            query: {projectType:this.form.projectType}})
        this.visible = false
        done()
      }else{
        done()
        this.visible = false
        this.$emit('addDialogFinish', this.form.projectType)
        this.form.projectType = ''
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.block {
//   height: 300px;
  overflow: auto;
}
/deep/.el-dialog__body {
  padding: 30px 25px 22px 0px;
}
/deep/.el-card.is-always-shadow {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
/deep/.el-timeline-item {
  width: 95%;
}
/deep/.el-dialog {
  border-radius: 8px;
}
.examineName {
  font-size: 14px;
  font-weight: bolder;
}
.warningtext {
  margin-left: 10px;
}
.examinereson {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  .advice_div {
    flex: 3;
    display: flex;
    flex-direction: row;
    .resons {
      width: 45px;
    }
  }
}
.advice_div {
  margin-left: 10px;
}
</style>
